import { AspidaResponse, BasicHeaders, HttpStatusOk } from 'aspida';
import { IdTokenResult } from 'firebase/auth';
import { apiClient } from '~/lib/apiClient';

type GachaCheckinResponse = {
  data?: AspidaResponse<
    { checked_gacha_ids: string[] },
    BasicHeaders,
    HttpStatusOk
  >;
};
/**
 * GPSもしくはデフォルトの座標でチェックインを行う
 * @param isRequiredGpsCheckin GPSでのチェックインが必要かどうか
 */
export const gachaCheckin = async (
  token: IdTokenResult | undefined
): Promise<GachaCheckinResponse> => {
  if (token == undefined) {
    throw new Error('token is not active');
  }

  try {
    const gpsResponse: GeolocationPosition = await new Promise(
      (resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => reject(error)
        );
      }
    );

    const apiResponse = await apiClient.v1.me.areas.post({
      headers: {
        Authorization: `Bearer ${token.token}`,
      },
      body: {
        latitude: gpsResponse.coords.latitude,
        longitude: gpsResponse.coords.longitude,
      },
    });
    return { data: apiResponse };
  } catch (e) {
    console.error('check in error', e);
    if ('code' in e) {
      throw e as GeolocationPositionError;
    } else {
      throw new Error(e);
    }
  }
};
